import { Input } from '@chiroup/components/form/Input';
import { HomePageSection, HomePageSubsection } from '@chiroup/core/types/HomePage.type';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { PlusCircleIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { v4 } from 'uuid';
import HomePageSortableItem from './HomePageSortableItem';

type Props = {
  subsection: HomePageSubsection;
  setData: React.Dispatch<React.SetStateAction<HomePageSection[]>>;
};

const HomePageList: React.FC<Props> = ({ subsection, setData }) => {
  const removeLink = (id: string) => {
    setData(prev => {
      prev = prev.map(v => {
        const subIndex = v.subsections.findIndex(s => s.id === subsection.id);

        if (subIndex !== -1) {
          v.subsections[subIndex].typeData = v.subsections[subIndex].typeData || {};
          (v.subsections[subIndex].typeData as any).list =
            (v.subsections[subIndex].typeData as any).list || [];
          (v.subsections[subIndex].typeData as any).list = (
            v.subsections[subIndex].typeData as any
          ).list.filter((l: any) => l.id !== id);
        }

        return v;
      });

      return prev;
    });
  };

  return (
    <div className="col-span-1 sm:col-span-6 grid sm:grid-cols-6 gap-2">
      <div>List items</div>
      <SortableContext
        id={`list-${subsection.id}`}
        items={subsection.typeData?.list || []}
        strategy={verticalListSortingStrategy}
      >
        <div className="col-span-1 sm:col-span-6 flex flex-col gap-2">
          {subsection.typeData?.list?.map(item => (
            <HomePageSortableItem key={item.id} id={item.id} removeItem={removeLink}>
              <div className="flex flex-col sm:flex-row gap-2 col-span-1 sm:col-span-6 w-full p-6 rounded-md bg-gray-50 border border-gray-300">
                <Input
                  name="text"
                  label="Title *"
                  className="w-full"
                  value={item.title}
                  onChange={val => {
                    setData(prev => {
                      prev = prev.map(v => {
                        const subIndex = v.subsections.findIndex(s => s.id === subsection.id);

                        if (subIndex !== -1) {
                          v.subsections[subIndex].typeData = v.subsections[subIndex].typeData || {};
                          (v.subsections[subIndex].typeData as any).list =
                            (v.subsections[subIndex].typeData as any).list || [];
                          (v.subsections[subIndex].typeData as any).list = (
                            v.subsections[subIndex].typeData as any
                          ).list?.map((l: any) => {
                            if (l.id !== item.id) {
                              return l;
                            }

                            return {
                              ...item,
                              title: val,
                            };
                          });
                        }

                        return v;
                      });

                      return prev;
                    });
                  }}
                />
                <Input
                  name="text"
                  label="Subtitle *"
                  className="w-full"
                  value={item.subtitle}
                  onChange={val => {
                    setData(prev => {
                      prev = prev.map(v => {
                        const subIndex = v.subsections.findIndex(s => s.id === subsection.id);

                        if (subIndex !== -1) {
                          v.subsections[subIndex].typeData = v.subsections[subIndex].typeData || {};
                          (v.subsections[subIndex].typeData as any).list =
                            (v.subsections[subIndex].typeData as any).list || [];
                          (v.subsections[subIndex].typeData as any).list = (
                            v.subsections[subIndex].typeData as any
                          ).list?.map((l: any) => {
                            if (l.id !== item.id) {
                              return l;
                            }

                            return {
                              ...item,
                              subtitle: val,
                            };
                          });
                        }

                        return v;
                      });

                      return prev;
                    });
                  }}
                />
                <Input
                  name="text"
                  label="URL *"
                  className="w-full"
                  value={item.url}
                  onChange={val => {
                    setData(prev => {
                      prev = prev.map(v => {
                        const subIndex = v.subsections.findIndex(s => s.id === subsection.id);

                        if (subIndex !== -1) {
                          v.subsections[subIndex].typeData = v.subsections[subIndex].typeData || {};
                          (v.subsections[subIndex].typeData as any).list =
                            (v.subsections[subIndex].typeData as any).list || [];
                          (v.subsections[subIndex].typeData as any).list = (
                            v.subsections[subIndex].typeData as any
                          ).list?.map((l: any) => {
                            if (l.id !== item.id) {
                              return l;
                            }

                            return {
                              ...item,
                              url: val,
                            };
                          });
                        }

                        return v;
                      });

                      return prev;
                    });
                  }}
                />
              </div>
            </HomePageSortableItem>
          ))}
        </div>
      </SortableContext>
      <PlusCircleIcon
        className="w-10 h-10 text-primary-500 hover:text-primary-400 cursor-pointer"
        onClick={() => {
          setData(prev => {
            prev = prev.map(v => {
              const subIndex = v.subsections.findIndex(s => s.id === subsection.id);

              if (subIndex !== -1) {
                v.subsections[subIndex].typeData = v.subsections[subIndex].typeData || {};
                (v.subsections[subIndex].typeData as any).list =
                  (v.subsections[subIndex].typeData as any).list || [];
                (v.subsections[subIndex].typeData as any).list.push({
                  id: v4(),
                  title: '',
                  url: '',
                });
              }

              return v;
            });

            return prev;
          });
        }}
      />
    </div>
  );
};

export default HomePageList;
